import { useGetProspectEmployees } from 'components/hooks/useGetProspectEmployees'

import CreateOrUpdateQuote, { type CreateOrUpdateQuoteProps } from './CreateOrUpdateQuote'

type Props = Required<CreateOrUpdateQuoteProps> & {
  isManualEntry: boolean
  prospectEmployeeCount: number
}

export function EditQuote ({
  prospectId,
  quoteId,
  censusId,
  isManualEntry,
  prospectEmployeeCount,
  nextStepPath,
  previousStepPath,
}: Props) {
  const { data: employees, isFetched } = useGetProspectEmployees({
    prospectId,
    censusId,
    pagination: { pageIndex: 1, pageSize: prospectEmployeeCount },
    enabled: isManualEntry,
  })

  // Transform ProspectEmployee data to EmployeeInfo format
  const transformedEmployees = employees?.data?.map(employee => ({
    first_name: employee.first_name || '',
    last_name: employee.last_name || '',
    email: employee.email || '',
    name: employee.name,
    date_of_birth: employee.date_of_birth,
    zip: employee.zip,
    dependents: employee.dependents.map(dep => ({
      relationship: dep.relationship,
      date_of_birth: dep.date_of_birth
    }))
  }))

  return (
    <div className='flex justify-center'>
      {(isFetched || !isManualEntry) && (
        <CreateOrUpdateQuote
          prospectId={prospectId}
          quoteId={quoteId}
          censusId={censusId}
          manualEntryEmployees={transformedEmployees}
          nextStepPath={nextStepPath}
          previousStepPath={previousStepPath}
        />
      )}
    </div>
  )
}

export default (props: Props) => {
  return (
    <EditQuote {...props} />
  )
}
